
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Anforderung from '@/types/Anforderung';
    import { VForm } from '@/types/Components';
    import { AnforderungenFilter, UpdateAnforderungPayload } from '@/store/anforderungen';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('anforderungen', ['loaders', 'dauer']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('anforderungen', ['loadAnforderungen', 'editAnforderung', 'updateAnforderung']),
            ...mapMutations('anforderungen', ['setDialogsDetail']),
        },
    })
    export default class AnforderungenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() anforderung!: Anforderung;
        @Prop() filter!: AnforderungenFilter;

        public $refs!: {
            form: VForm;
        };

        public updateAnforderung!: (payload: UpdateAnforderungPayload) => void;

        public get isEdit(): boolean {
            return this.anforderung.anforderung_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateAnforderung({ anforderung: this.anforderung, filter: this.filter });
            }
        }
    }
